/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-props-no-spreading */
import React from "react"
import clsx from "clsx"
import { ReactComponent as Advertencia } from "./advertencia-amarillo.svg"
import { ReactComponent as BanderaChile } from "./bandera-Chile.svg"
import { ReactComponent as BanderaPeru } from "./bandera-Peru.svg"
import { ReactComponent as Borrar } from "./R-Borrar.svg"
import { ReactComponent as Check } from "./R-Check.svg"
import { ReactComponent as CheckEstrellas } from "./Check-estrellas.svg"
import { ReactComponent as CrearCuenta } from "./crear-cuenta.svg"
import { ReactComponent as Ganar } from "./ganar.svg"
import { ReactComponent as JPGFile } from "./R-Jpg.svg"
import { ReactComponent as LogoMercadoBlanco } from "./logo-mercado-blanco.svg"
import { ReactComponent as LogoMercadoRipley } from "./logo-mercado-ripley.svg"
import { ReactComponent as LogoRipleyBlanco } from "./logo-ripley-blanco.svg"
import { ReactComponent as OnErrorRocket } from "./Rocket-cohete.svg"
import { ReactComponent as Ordenes } from "./R-Ordenes.svg"
import { ReactComponent as Portal } from "./portal.svg"
import { ReactComponent as Visible } from "./visible.svg"

export const AdvertenciaIcon = props => (
  <Advertencia
    {...props}
    className={clsx("MuiSvgIcon-root", props.className)}
  />
)

export const BanderaChileIcon = props => (
  <BanderaChile
    {...props}
    className={clsx("MuiSvgIcon-root", props.className)}
  />
)

export const BanderaPeruIcon = props => (
  <BanderaPeru
    {...props}
    className={clsx("MuiSvgIcon-root", props.className)}
  />
)

export const BorrarIcon = props => (
  <Borrar
    {...props}
    className={clsx("MuiSvgIcon-root", props.className)}
  />
)

export const CheckIcon = props => (
  <Check
    {...props}
    className={clsx("MuiSvgIcon-root", props.className)}
  />
)

export const CheckEstrellasIcon = props => (
  <CheckEstrellas
    {...props}
    className={clsx("MuiSvgIcon-root", props.className)}
  />
)

export const CrearCuentaIcon = props => (
  <CrearCuenta
    {...props}
    className={clsx("MuiSvgIcon-root", props.className)}
  />
)

export const GanarIcon = props => (
  <Ganar
    {...props}
    className={clsx("MuiSvgIcon-root", props.className)}
  />
)

export const JPGFileIcon = props => (
  <JPGFile
    {...props}
    className={clsx("MuiSvgIcon-root", props.className)}
  />
)

export const LogoMercadoBlancoIcon = props => (
  <LogoMercadoBlanco
    {...props}
    className={clsx("MuiSvgIcon-root", props.className)}
  />
)

export const LogoMercadoRipleyIcon = props => (
  <LogoMercadoRipley
    {...props}
    className={clsx("MuiSvgIcon-root", props.className)}
  />
)

export const LogoRipleyBlancoIcon = props => (
  <LogoRipleyBlanco
    {...props}
    className={clsx("MuiSvgIcon-root", props.className)}
  />
)

export const OnErrorRocketIcon = props => (
  <OnErrorRocket
    {...props}
    className={clsx("MuiSvgIcon-root", props.className)}
  />
)

export const OrdenesIcon = props => (
  <Ordenes
    {...props}
    className={clsx("MuiSvgIcon-root", props.className)}
  />
)

export const PortalIcon = props => (
  <Portal
    {...props}
    className={clsx("MuiSvgIcon-root", props.className)}
  />
)

export const VisibleIcon = props => (
  <Visible
    {...props}
    className={clsx("MuiSvgIcon-root", props.className)}
  />
)